import React, { Component } from 'react';
import { FaLinkedin, FaTwitterSquare } from 'react-icons/fa';

class FixedFooter extends Component {
  componentDidMount() {
  }
  render() {
    const props = this.props;
    // console.log(props);
    return (
      <div className="footer text-center">
        Mackral &copy;2020
        {/* <Link to="#">
          <FaFacebookSquare></FaFacebookSquare>
        </Link> */}
        <a href="https://www.linkedin.com/in/mackral" target="_blank" rel="noopener noreferrer">
          <FaLinkedin></FaLinkedin>
        </a>
        <a href="https://twitter.com/i_am_mackral" target="_blank" rel="noopener noreferrer">
          <FaTwitterSquare></FaTwitterSquare>
        </a>
      </div>
    );
  }
}
export default FixedFooter;
